import { type schemaType } from '~~/shared/api/rurality/v3/cottages/recommended-by-cottage/detail/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/cottages/recommended-by-cottage/detail/paramsSchema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/cottages/recommended-by-cottage/detail'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapper<paramsType, schemaType>(endpoint, params)
